<script>
import { Entity } from '@/classes/Entity';

export default {
	name: 'BaseTool',
	props: {
		scenario: {
			type: Object,
			required: true,
		},
		entity: {
			type: Entity,
			default: null,
		},
		expanded: {
			type: Boolean,
			required: true,
		},
		panel: {
			type: String,
			required: true,
		},
		currentlyResizable: {
			default: false,
			type: Boolean,
		},
		theoreticallyResizable: {
			default: false,
			type: Boolean,
		},
	},
	methods: {
		async updateTour(scenarioId, tourId, tourData) {
			try {
				this.axios.patch(`/scenarios/${scenarioId}/tours/${tourId}`, tourData).then((response) => {
					if (response.status === 200) {
						this.$bvToast.toast(this.$t('tours.notify-update'), {
							title: this.$t('toast.success'),
							variant: 'success',
						});
						return response.data;
					}
					return false;
				});
			} catch (error) {
				console.error(error);
				this.$bvToast.toast(this.$t('tours.notify-error'), {
					title: this.$t('toast.error'),
					variant: 'danger',
				});
			}
		},
		copyStop(index) {
			this.setTourClipboard(this.activeTour.data.stops[index]);
		},
		pasteStop(index = null) {
			this.addActiveTourStop(this.getTourClipboard);
			if (index !== null) {
				const endOfTourStops = this.activeTour.data.stops.length - 1;
				this.moveActiveTourStop({ oldIndex: endOfTourStops, newIndex: index });
			}
			this.updateTour(
				this.activeTour.scenarioId,
				this.activeTour.id,
				JSON.parse(JSON.stringify(this.activeTour))
			);
		},
	},
};
</script>
